import { React } from 'react';
import './SiteCard.css';

function SiteCard(props) {
	return <div className="site-card">{props.children}</div>
}

export default SiteCard;